import JobProfile from "./JobProfile";

export { JobProfile as default };
